import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { CheckoutPrice } from '@sharedComponents/Prices';
import { IBasicTestProps } from '@styles/model';
import { CypressTestNamespace } from '@utils/test';

export const StyledFreeDeliveryWrapper = styled.div.attrs<IBasicTestProps>(() => ({
  className: CypressTestNamespace.EFreeDeliveryProgressBar.FREE_DELIVERY_WRAPPER,
}))`
  background-color: #f5f5f5;
  min-height: 5.125rem;
  align-content: center;

  @media (max-width: ${theme.breakpoints.md}rem) {
    margin-right: -1rem;
    margin-left: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const StyledIconWrapper = styled.div`
  display: flex;
`;

export const StyledText = styled.div<{ isCompleted: boolean }>`
  font-size: 1rem;
  margin-left: 0.9rem;
  font-weight: ${({ isCompleted }) => (isCompleted ? 'bold' : 'normal')};
  color: ${({ isCompleted }) => (isCompleted ? theme.color.text.highlight : theme.color.text.primary)};

  @media (max-width: ${theme.breakpoints.md}rem) {
    font-size: 0.875rem;
  }
`;

export const StyledTextRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0.25rem 2rem;
  margin: auto;

  @media (max-width: ${theme.breakpoints.md}rem) {
    padding: 0.25rem 0;
  }
`;

export const StyledCheckoutPrice = styled(CheckoutPrice)`
  align-items: center;
  color: ${theme.color.text.highlight};
  padding: 0 0.25rem;
  display: inline-flex;
`;

export const StyledLink = styled.a`
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  text-decoration: underline;
  transition: color 300ms ease;
  font-weight: 600;
  cursor: pointer;
  color: ${theme.color.text.highlight};
  &:hover {
    text-decoration: none;
  }
`;
